<template>
  <esg-table-without-meta :items="items"
                          :fields="fields"
                          size="sm"
                          max-height="250px">
    <template #thead-top>
      <tr>
        <th colspan="4"><span>법인 정보</span></th>
        <th colspan="4"><span>제품 정보</span></th>
        <th colspan="5"><span>배출활동 정보</span></th>
        <th colspan="2"><span>연간 생산량</span></th>
        <th colspan="2"><span>배출량</span></th>
      </tr>
    </template>
  </esg-table-without-meta>
</template>
<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: { EsgTableWithoutMeta },
  // 생산 공정 배출량 상세 정보 - 배출
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchData()
      }
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return
      if (!this.year) return

      try {
        // Chart meta data
        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode]
        }]

        // Construct form data for HTTP request
        let data = new FormData()
        data.append('path', 'esg/lca/waste_detail/main')
        data.append('json', JSON.stringify(args))

        // Request data for the chart
        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
                if (!response.data.data) {
          this.series = [];
          return;
        }


        // Parse JSON data
        let tableData = JSON.parse(response.data.data)[0].data;

        // Filter out the data in the past
        let items = []

        let prevIdx = -1
        let currIdx = -1
        let currHeader = null
        let total = 0
        let totalPerProduction = 0
        tableData.forEach(row => {
          // Current index is the production ID of the row
          currIdx = row.production_id

          // When a new group starts
          if (currIdx !== prevIdx) {
            // Create a new row and push it to the new array
            let newRow = Object.assign({}, row)
            newRow.activity_id = '-'
            newRow.activity_category = '-'
            newRow.activity_subcategory = '-'
            newRow.activity_item = '-'
            newRow.carbon_emission_amount = 0
            newRow.carbon_emission_per_production_amount = 0

            // Push it to the new array
            items.push(newRow)
            prevIdx = currIdx

            // Add GHG emissions to totals and change header
            if (currHeader) {
              total += currHeader.carbon_emission_amount
              totalPerProduction += currHeader.carbon_emission_per_production_amount
            }
            currHeader = newRow
          }

          // Push the current row
          row.product_amount = '-'
          row.product_unit = '-'
          currHeader.carbon_emission_amount += row.carbon_emission_amount
          currHeader.carbon_emission_per_production_amount += row.carbon_emission_per_production_amount
          items.push(row)
        })

        // For the last header, add GHG emissions to totals
        if (currHeader) {
          total += currHeader.carbon_emission_amount
          totalPerProduction += currHeader.carbon_emission_per_production_amount
        }

        this.items = items
        this.total = total
        this.totalPerProduction = totalPerProduction

        this.$emit('totalCalculated', total, totalPerProduction)
      } catch (error) {
        await this.showError(error)
      }
    },
  },
  data() {
    return {
      currYear: new Date().getFullYear(),
      total: 0,
      totalPerProduction: 0,
      items: [],
      fields: [
        {
          name: "corporation_code",
          label: "법인 코드",
          list: true,
          sortable: true
        },
        {
          name: "corporation_name",
          label: "법인",
          list: true,
          sortable: true,
          filtered: true
        },
        {
          name: "business_location_code",
          label: "사업장 코드",
          list: true,
          sortable: true
        },
        {
          name: "business_location_name",
          label: "사업장",
          list: true,
          sortable: true,
          filtered: true
        },
        {
          name: "product_family_code",
          label: "제품군 코드",
          list: true,
        },
        {
          name: "product_family_name",
          label: "제품군",
          list: true,
        },
        {
          name: "product_code",
          label: "제품 코드",
          list: true,
        },
        {
          name: "product_name",
          label: "제품명",
          list: true,
        },
        {
          name: "activity_category",
          label: "배출구분",
          list: true,
          filtered: true
        },
        {
          name: "activity_subcategory",
          label: "처리방식",
          list: true,
          filtered: true
        },
        {
          name: "activity_item",
          label: "배출항목",
          list: true,
          filtered: true
        },
        {
          name: "waste_amount",
          label: "폐기물 배출량",
          list: true,
        },
        {
          name: "waste_unit",
          label: "배출 단위",
          list: true,
        },
        {
          name: "product_amount",
          label: "제품 생산량",
          list: true,
        },
        {
          name: "product_unit",
          label: '생산 단위',
          list: true,
        },
        {
          name: "carbon_emission_per_production_amount",
          label: "단위 배출량\n(tCO2e)",
          formatter: val => this.formatNumber(val),
          list: true,
          sortable: true
        },
        {
          name: "carbon_emission_amount",
          label: '연간 배출량\n(tCO2e)',
          formatter: val => this.formatNumber(val),
          list: true,
          sortable: true
        },
      ]
    }
  },
}
</script>
